<template>
  <div class="customerDetail">
    <div class="header">
      <div class="dropdownMenu">
        <div class="dropdown dropleft">
          <button
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
          >
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-container">
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <h5 class="dropdown-heading">Schedules</h5>
              <div class="dropdown-item-wrap">
                <img :src="demotask" alt="Edit"/>
                <a class="dropdown-item" href="#">Set Demo Date</a>
              </div>
              <div class="dropdown-item-wrap">
                <img :src="setfollowup" alt="Edit"/>
                <a class="dropdown-item" href="#">Set Followup Date</a>
              </div>
              <div class="dropdown-item-wrap">
                <img :src="setestimated" alt="Edit"/>
                <a class="dropdown-item" href="#">Set Estimated Value</a>
              </div>
              <div class="border"></div>
              <h5 class="dropdown-heading">Priority</h5>
              <div class="dropdown-icon-wrap" :class="{ 'set-height': setHeight }">
                <div class="dropdown-item-wrap">
                  <img :src="setpriority" alt="Edit"/>
                  <a class="dropdown-item" @click.stop="togglePriorityDropdown">Select Priority</a>

                  <div
                      class="dropdown-menu second-dropdown"
                      :class="{ 'dropdown-menu-right': showPriorityDropdown }"
                      v-show="showPriorityDropdown"
                  >
                    <a class="dropdown-item" href="#">No Priority</a>
                    <a class="dropdown-item" href="#">Less Interested</a>
                    <a class="dropdown-item" href="#">Interested</a>
                    <a class="dropdown-item set-item-style" href="#"
                    >Highly Interested</a
                    >
                  </div>
                </div>
                <div class="dropdown-icon" @click.stop="togglePriorityDropdown">
                  <img :src="dropdownarrow" alt="Edit"/>
                </div>
              </div>
              <div class="border"></div>
              <div class="dropdown-item-wrap">
                <img :src="deleteIcon" alt="Edit"/>
                <a class="dropdown-item" href="#">Delete</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="statusWrapper">-->
<!--      <div class="status1 statusBadge">INACTIVE</div>-->
<!--      <div class="status2 statusBadge">qualified</div>-->
<!--    </div>-->
    <div class="customerInfo">
      <div class="customerImg">
        <img :src="avatarIcon" alt=""/>
      </div>
      <div class="customerName">
        <h1
            class="customerNameText"
            :class="isEditable.name ? 'focusInput' : ''"
            :contenteditable="isEditable.name"
            @input="updateText('name', $event)"
            ref="editableName"
        >
          {{ user.user_name }}
        </h1>

        <div class="customerNameEdit">
         
        </div>
      </div>

      <v-row class="justify-content-center">
        <div class="contact-wrapper">
          <v-col
              cols="12"
          >
            <div class="contactSource row justify-content-between align-items-baseline">
              <v-col
                  cols="" class="contact-col"
              >
                <div class="contact-cards">
                  <a @click.prevent="openTab('Notes')">
                    <img :src="notesIcon" alt=""/>
                  </a>
                </div>
                <a>
                  <span class="card-heading2">Notes</span>
                </a>
              </v-col>
              <v-col
                  cols="" class="contact-col"
              >
                <div class="contact-cards" @click.prevent="openTab('Email')">
                  <a>
                    <img :src="emailIcon" alt=""/>
                  </a>
                </div>
                <a>
                  <span class="card-heading2">Email</span>
                </a>
              </v-col>
              <v-col
                  cols="" class="contact-col"
              >
                <div class="contact-cards">
                  <a href="">
                    <img :src="callIcon" alt=""/>
                  </a>
                </div>
                <a href="">
                  <span class="card-heading2"> Call </span>
                </a>
              </v-col>
              <v-col
                  cols="" class="contact-col"
              >
                <div class="contact-cards" @click.prevent="openTab('Meet')">
                  <a>
                    <img :src="meetIcon" alt=""/>
                  </a>
                </div>
                <a>
                  <span class="card-heading2">Meet</span>
                </a>
              </v-col>
            </div>
          </v-col>
        </div>
      </v-row>
    </div>
    <v-row class="justify-content-center">
      <div class="progress-wrapper">
        <v-col cols="xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <b-progress class="mt-2" :max="progressMax">
            <b-progress-bar
                v-b-tooltip.bottom="''"
                :value="progressValue * (3.33 / 10)"
                variant="success"
            ></b-progress-bar>
            <b-progress-bar
                v-b-tooltip.bottom="''"
                :value="progressValue * (3.33 / 10)"
                variant="warning"
            ></b-progress-bar>
            <b-progress-bar
                v-b-tooltip.bottom="''"
                :value="progressValue * (3.33 / 10)"
                variant="danger"
            ></b-progress-bar>
          </b-progress>
        </v-col>
      </div>
    </v-row>
  

    <v-row>
      <v-col cols="12">
        <div class="detailborder-bottom"></div>
      </v-col>
    </v-row>

    <div class="customer-info-wrapper hide-scroll">
      <v-row>
        <v-col cols="12">
          <div class="customer-info">
            <h3 class="main-heading">Organization Details</h3>
            <div class="customer-name2">
              <h5 class="sub-heading1">Name</h5>
              <div class="customerNameEdit2">
                <h6
                    class="sub-heading2"
                    :class="user.user_name ? 'focusInput' : ''"
                    :contenteditable="user.legal_name"
                    @input="updateText('username', $event)"
                    ref="editableUsername"
                >
                  {{ user.legal_name || '..' }}
                </h6>
                <div class="customerNameEdit">
                
                </div>
              </div>
            </div>
            <div class="customer-name2">
              <h5 class="sub-heading1">Email</h5>
              <div class="customerNameEdit2">
                <h6
                    class="sub-heading2"
                    :class="user.email ? 'focusInput' : ''"
                    :contenteditable="user.email"
                    @input="updateText('email', $event)"
                    ref="editableEmail"
                >
                  {{ user.email || '..' }}
                </h6>
                <div class="customerNameEdit">
                
                </div>
              </div>
            </div>
            <div class="customer-name2">
              <h5 class="sub-heading1">Phone</h5>
              <div class="customerNameEdit2">
                <h6
                    class="sub-heading2"
                    :class="user.phone ? 'focusInput' : ''"
                    :contenteditable="user.phone"
                    @input="updateText('phone', $event)"
                    ref="editablePhone"
                >
                  {{ user.phone || '..' }}
                </h6>
                <div class="customerNameEdit">
          
                </div>
              </div>
            </div>
            <div class="customer-name2">
              <h5 class="sub-heading1">Address</h5>
              <div class="customerNameEdit2">
                <h6
                    class="sub-heading2"
                    :class="user.street_address ? 'focusInput' : ''"
                    :contenteditable="user.street_address"
                    @input="updateText('username', $event)"
                    ref="editableUsername"
                >
                  {{ user.street_address ? `${user.street_address},` : '..'}}
                </h6>
                <div class="customerNameEdit">
              
                </div>
              </div>
            </div>
            <div class="customer-name2">
              <h5 class="sub-heading1">Fax</h5>
              <div class="customerNameEdit2">
                <h6
                    class="sub-heading2"
                    :class="user.fax ? 'focusInput' : ''"
                    :contenteditable="user.fax"
                    @input="updateText('username', $event)"
                    ref="editableUsername"
                >
                  {{ user.fax || ".." }}
                </h6>
                <div class="customerNameEdit">
              
                </div>
              </div>
            </div>

          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import pencilEdit from "@/assets/images/pencil-edit.svg";
import notesIcon from "@/assets/images/notes.svg";
import emailIcon from "@/assets/images/email.svg";
import callIcon from "@/assets/images/call.svg";
import meetIcon from "@/assets/images/meet.svg";
import taskIcon from "@/assets/images/task.svg";
import tickIcon from "@/assets/images/tick.svg";
import demotask from "@/assets/images/demo-task.svg";
import setestimated from "@/assets/images/set-estimated.svg";
import setfollowup from "@/assets/images/set-followup.svg";
import setpriority from "@/assets/images/set-priority.svg";
import dropdownarrow from "@/assets/images/dropdown-arrow.svg";
import deleteIcon from "@/assets/images/delete-icon.svg";
import avatarIcon from "@/assets/images/avatar7.png";
import axios from "axios";
import helpers from "@/helpers";

export default {
  name: "CustomerDetail",
  prop: {userId: null,organizationId: null},
  data() {
    return {
      isEditable: {
        name: false,
        username: false,
        email: false,
        phone: false,
        fax: false,
        address: false,
        priority: false,
        status: false,
      },
      name: "Customer Name",
      username: "john-doe",
      email: "john-doe@emailaddress.com",
      phone: "+1 234 567890",
      fax: "+1 234 567890",
      address: "940 Goldendale Dr, Wasilla, Alaska 99654, USA",
      priority: "high",
      status: "qualified",
      originalValues: {
        name: "Customer Name",
        username: "john-doe",
        email: "john-doe@emailaddress.com",
        phone: "+1 234 567890",
        fax: "+1 234 567890",
        address: "940 Goldendale Dr, Wasilla, Alaska 99654, USA",
        priority: "high",
        status: "qualified",
      },
      showPriorityDropdown: false,
      setHeight: false,
      pencilEdit: pencilEdit,
      notesIcon: notesIcon,
      emailIcon: emailIcon,
      callIcon: callIcon,
      meetIcon: meetIcon,
      taskIcon: taskIcon,
      tickIcon: tickIcon,
      avatarIcon: avatarIcon,
      progressValue: 100,
      progressMax: 100,
      demotask: demotask,
      setestimated: setestimated,
      setfollowup: setfollowup,
      setpriority: setpriority,
      dropdownarrow: dropdownarrow,
      deleteIcon: deleteIcon,

      //data props
      page: 0,
      tab: 1,
      leadId: null,
      leadWithData: null,
      customerDetail: [],
      image_path: '',
      notes: {},
      orgDocs: {},
      terms: {},
      userId: this.userId || this.$route.params.user
    };
  },

  mounted() {
    this.leadId = this.$route.params.id;
  },
  computed: {
    user: function () {
      return this.$store.getters['organizations/organization'];
    },
  },

  created: function () {
    this.page = helpers.getPageQuery();
    // this.$store.dispatch('users/getUser',this.$route.params.user, this.$route.params.organization_id);
    this.getUser()
    this.image_path = process.env.VUE_APP_LINENTECH_V3;
    this.getAllDocs();
  },

  methods: {
    getUser() {
      this.$store.dispatch('organizations/getOrganizationById', [this.userId, this.organizationId])
    },
    setPage(page) {
      this.page = page;
      this.$router.push('/users/' + this.userId + '/posts?page=' + page);
    },

    getAllDocs() {
      axios.get('admin/organization/document/' +  this.$route.params.organization_id)
          .then((response) => {
            this.orgDocs = response.data.organization;
          });
    },
    // get mimeType from file extension for passing blob object
    getMimetype(fileExtension) {
      switch (fileExtension) {
        case 'png':
          return 'image/png';
        case 'gif':
          return 'image/gif';
        case 'pdf':
          return 'application/pdf';
        case 'jpg':
          return 'image/jpeg';
        case 'xls':
        case 'xlt':
        case 'xla':
          return 'application/vnd.ms-excel';
        case 'doc':
          return 'application/msword';
        case 'docx':
        case 'dotx':
          return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      }
    },

    togglePriorityDropdown() {
      this.showPriorityDropdown = !this.showPriorityDropdown;
      this.setHeight = !this.setHeight;
    },
    toggleEdit(field) {
      if (!this.isEditable[field]) {
        this.originalValues[field] = this[field];
      }
      this.isEditable[field] = !this.isEditable[field];
      this.$nextTick(() => {
        if (this.isEditable[field]) {
          this.$refs[
              `editable${field.charAt(0).toUpperCase() + field.slice(1)}`
              ].focus();
        }
      });
    },
    updateText(field, event) {
      this[field] = event.target.innerText;
    },
    saveEdit(field) {
      this.isEditable[field] = false;
    },
    cancelEdit(field) {
      this[field] = this.originalValues[field];
      this.isEditable[field] = false;
    },

    openTab(tabName) {
      this.$emit('tab-selected', tabName);
    },


  },
};
</script>
